import { render, staticRenderFns } from "./colegios_descargar.vue?vue&type=template&id=2d94cfbc"
import script from "./colegios_descargar.vue?vue&type=script&lang=js"
export * from "./colegios_descargar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports